import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d1eff3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xml-formatter m-16" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "XML Formatter", -1))
const _hoisted_3 = { class: "button-container" }
const _hoisted_4 = {
  key: 0,
  class: "text-left bg-slate-900 border border-slate-700 p-4 rounded-lg text-slate-300 my-4 whitespace-pre-wrap break-words overflow-x-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("textarea", {
      class: "w-[80%] h-[100px] p-2.5 mb-4 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50 resize-y",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.xmlInput) = $event)),
      placeholder: "Enter XML"
    }, null, 512), [
      [_vModelText, _ctx.xmlInput]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "format-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.formatXML && _ctx.formatXML(...args)))
      }, "Format XML")
    ]),
    (_ctx.formattedXml)
      ? (_openBlock(), _createElementBlock("pre", _hoisted_4, _toDisplayString(_ctx.formattedXml), 1))
      : _createCommentVNode("", true),
    (_ctx.formattedXml)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "copy-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyToClipboard(_ctx.formattedXml)))
        }, "Copy Formatted XML"))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["snackbar", { show: _ctx.showSnackbar }])
    }, "Copied to clipboard!", 2)
  ]))
}